import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { RepositoryNameDropdown } from './RepositoryNameDropdown';

export const RepositoryNameDropdownFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'RepositoryNameDropdown',
    component: RepositoryNameDropdown,
  }),
);
